<template>
    <div>
        <div class="form__group">
            <label class="form__label  form__label--block">{{ getTranslation('tests') }}</label>
            <v-select
                    v-model="testId"
                    :options="testings"
                    ref="testingSelect"
                    :reduce="option=>option.id"
                    :placeholder="getTranslation('selectFromList')"
                    label="title"
            />
        </div>
    </div>
</template>

<script>
    export default {
        name: "TestingSelectComponent",
        data() {
            return {
                testings: [],
                timer: null,
                testId: '',
                showSelect: false,
            }
        },
        created() {
            this.fetchTestings();
        },
        watch: {
            'testId'(id) {
                this.$emit('input', id);
                if (!id) {
                    this.fetchTestings();
                }
            }
        },
        mounted() {
            let searchInput = this.$refs.testingSelect.$el.getElementsByClassName('vs__search'),
                searchText = '';
            if (searchInput.length > 0) searchInput[0].oninput = e => {
                if (this.timer) clearTimeout(this.timer);
                if (searchText !== e.target.value) {
                    this.timer = setTimeout(() => {
                        searchText = e.target.value;
                        this.searchTesting(searchText);
                        this.timer = null;
                    }, 500);
                }
            };

        },
        methods: {
            searchTesting(searchText) {
                let params = {};
                if (searchText) params.query = searchText;
                return this.axios.get(this.$config.urls.testing.fetchTests.url, {params: params})
                    .then(response => {
                        this.testings = response.data.data.items;
                    })
            },
            fetchTestings() {
                return this.axios.get(this.$config.urls.testing.fetchTests.url)
                    .then(response => {
                        this.testings = response.data.data.items;
                    })
            }
        },
    }
</script>

<style scoped>

</style>